module.exports = __webpack_public_path__ + "img/title-page-img.e2f8a592.png";